export default __webpack_public_path__ + "static/media/avatarDoc.df0fb35f.png";